var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsEnum, IsNumber, IsOptional, IsString, } from 'class-validator';
import { ReservationPaymentType } from '../../../enums';
export class CreateReservationPaymentDto {
}
__decorate([
    IsEnum(ReservationPaymentType),
    __metadata("design:type", String)
], CreateReservationPaymentDto.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateReservationPaymentDto.prototype, "category", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], CreateReservationPaymentDto.prototype, "date", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateReservationPaymentDto.prototype, "fee", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateReservationPaymentDto.prototype, "managerId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateReservationPaymentDto.prototype, "memo", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateReservationPaymentDto.prototype, "bankCardId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateReservationPaymentDto.prototype, "reservationId", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateReservationPaymentDto.prototype, "settlementId", void 0);
